import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import computeInsertPosition from '../../utils/computeInsertPosition';
import getDefaultPosition from '../../utils/getDefaultPosition';
import generateKey from '../../utils/generateKey';
import insertInArray from '../../utils/insertInArray';

function getRecord(database, recordKey) {
  return database.value.records[recordKey];
}

function getRecords(database) {
  return database.value.records;
}

function getRecordsCount(database) {
  return Object.keys(database.value.records).length;
}

function getPositionedRecords(database) {
  return Object.values(getRecords(database)).sort(database.getDefaultSort());
}

function getSortedRecords(database) {
  var compare = database.getSortStrategy();
  var records = database.value.records;
  var recordsValues = Object.values(records);

  if (database.getFrozenOrder()) {
    return database.getOrderedRecords(records);
  }

  return recordsValues.sort(compare);
}

function getRecordBefore(database, recordKey) {
  var sortedRecords = database.getSortedRecords();
  var currentIndex = sortedRecords.findIndex(function (_ref) {
    var key = _ref.key;
    return key === recordKey;
  });
  return sortedRecords[currentIndex - 1];
}

function getRecordAfter(database, recordKey) {
  var sortedRecords = database.getSortedRecords();
  var currentIndex = sortedRecords.findIndex(function (_ref2) {
    var key = _ref2.key;
    return key === recordKey;
  });
  return sortedRecords[currentIndex + 1];
}

function getFirstRecord(database) {
  return database.getSortedRecords()[0];
}

function getLastRecord(database) {
  return database.getSortedRecords()[database.getRecordsCount() - 1];
}

function insertRecord(database, attrs) {
  var lastRecord = getLastRecord(database);
  database.setFrozenOrder();
  return database.applyAction({
    type: 'insertRecord',
    payload: {
      attrs: _objectSpread({
        position: getDefaultPosition(lastRecord ? lastRecord.position : 0)
      }, attrs),
      currentUserId: database.currentUserId
    }
  });
}

function insertRecordBefore(database, recordKey) {
  var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var key = attrs.key || generateKey();
  database.setFrozenOrder(function (order) {
    return insertInArray(order, recordKey, key);
  });
  database.insertRecord(_objectSpread({}, attrs, {
    key: key,
    position: computeInsertPosition(database.getPositionedRecords(), database.value.records[recordKey], 'before')
  }));
}

function insertRecordAfter(database, givenRecordKey) {
  var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var recordKey = givenRecordKey || database.getActiveRecordKey();
  var key = attrs.key || generateKey();
  database.setFrozenOrder(function (order) {
    return insertInArray(order, recordKey, key, 'after');
  });
  database.insertRecord(_objectSpread({}, attrs, {
    key: key,
    position: computeInsertPosition(database.getPositionedRecords(), database.value.records[recordKey], 'after')
  }));
}

function deleteRecord(database, recordKey) {
  return database.applyAction({
    type: 'deleteRecord',
    payload: {
      recordKey: recordKey
    }
  });
}

export default {
  commands: {
    insertRecord: insertRecord,
    insertRecordBefore: insertRecordBefore,
    insertRecordAfter: insertRecordAfter,
    deleteRecord: deleteRecord
  },
  queries: {
    getRecord: getRecord,
    getRecords: getRecords,
    getRecordsCount: getRecordsCount,
    getPositionedRecords: getPositionedRecords,
    getSortedRecords: getSortedRecords,
    getFirstRecord: getFirstRecord,
    getLastRecord: getLastRecord,
    getRecordBefore: getRecordBefore,
    getRecordAfter: getRecordAfter
  }
};